import { LifecycleTaskPanel } from '@/components/fleet/lifecycle-task-panel';
import { TaskStatusPanel } from '@/components/fleet/task-status-panel';
import type { UseFleetAction } from '@/hooks/use-fleet-action';
import type { UseLifecycleAction } from '@/hooks/use-lifecycle-action';

/**
 * The task panels for runs started from `ActionMenu`. Both hosts of the menu
 * (the server detail page and the fleet list's row menu) render this, so run
 * tracking looks the same from either.
 */
export function ServerActionPanels({
  serverName,
  action,
  lifecycle,
}: {
  serverName: string;
  action: UseFleetAction;
  lifecycle: UseLifecycleAction;
}): JSX.Element {
  return (
    <>
      <TaskStatusPanel
        activeRun={action.activeRun}
        serverName={serverName}
        onDismiss={action.dismiss}
      />

      <LifecycleTaskPanel
        activeRun={lifecycle.activeRun}
        serverName={serverName}
        onDismiss={lifecycle.dismiss}
      />
    </>
  );
}
